const ColorConstants = {
  greenRGB: 'rgba(75, 192, 192)',
  greenRGBA: 'rgba(75, 192, 192, 0.2)',
  whiteRGBA: 'rgba(255, 255, 255, 0.2)',
  redRGB: 'rgba(255, 99, 132)',
  redRGBA: 'rgba(255, 99, 132, 0.2)',
};

export default ColorConstants;
